<template>
  <el-select
    v-model="val"
    :size="size"
    filterable
    remote
    :multiple="multiple"
    :reserve-keyword="reserveKeyword"
    :clearable="clearable"
    :placeholder="placeholder"
    :remote-method="remoteMethod"
    :loading="loading"
    :disabled="disabled"
    @change="handleChange"
  >
    <el-option
      v-for="point in skill_points"
      :key="point.id"
      :label="point.name"
      :value="point.id"
    ></el-option>
  </el-select>
</template>

<script>
import kcellService from "@/global/service/kcell";

export default {
  props: {
    value: {
      type: [Number, Array],
      default: null
    },
    skills: {
      type: Array
    },
    size: {
      type: String,
      default: "mini"
    },
    multiple: {
      type: Boolean,
      default: false
    },
    reserveKeyword: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: "关联技能栈"
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      val: null,
      loading: false,
      skill_points: []
    };
  },
  created() {
    if (this.skills) this.skill_points = this.skills;
  },
  watch: {
    value(val) {
      this.val = val;
    },
    val(val) {
      this.$emit("update:value", val);
    },
    skill_points(val) {
      this.$emit("update:skills", val);
    }
  },
  methods: {
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        kcellService
          .kcellSkills({ name: query })
          .then(res => {
            this.skill_points = res;
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.skill_points = [];
      }
    },
    handleChange(e) {
      this.$emit("change", e);
    }
  }
};
</script>
